<template>
  <div class="Crisis_addmulti_talk">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="发起会议时间" prop="name" class="hysj">
        <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.hysj" style="width: 100%;"></el-date-picker>
      </el-form-item>
      <el-form-item label="会议发起人" prop="name" class="fqr">
        <el-input v-model="ruleForm.fqr" placeholder="请输入会议发起人"></el-input>
      </el-form-item>
      <el-form-item label="发起人院所" prop="name" class="fqrys">
        <el-input v-model="ruleForm.fqrys" placeholder="请输入发起人院所"></el-input>
      </el-form-item>
      <h2 style="margin-left: 20px;padding-bottom: 20px;">危机学生基本信息</h2>
      <el-form-item label="学生学号" prop="name" class="xuxh">
        <el-input v-model="ruleForm.xuxh" placeholder="请输入学生学号"></el-input>
      </el-form-item>
      <el-form-item label="学生姓名" prop="name" class="xuxm">
        <el-input v-model="ruleForm.name" placeholder="请输入学生姓名"></el-input>
      </el-form-item>
      <h2 style="margin-left: 20px;padding-bottom: 20px;">危机学生情况简要描述</h2>
      <el-form-item prop="desc">
        <el-input type="textarea" v-model="ruleForm.desc"></el-input>
      </el-form-item>
      <h2 style="margin-left: 20px;padding-bottom: 20px;">会议发起原因及诉求</h2>
      <el-form-item prop="desc">
        <el-input type="textarea" v-model="ruleForm.desc"></el-input>
      </el-form-item>
      <h2 style="margin-left: 20px;padding-bottom: 20px;">与会部门/人员</h2>
      <el-form-item prop="desc" class="cgtrh">
        <el-checkbox-group v-model="ruleForm.type">
          <el-checkbox label="心理辅导员"></el-checkbox>
          <el-checkbox label="心理中心"></el-checkbox>
          <el-checkbox label="院所领导"></el-checkbox>
          <el-checkbox label="学生本人"></el-checkbox>
          <el-checkbox label="学生监护人"></el-checkbox>
          <el-checkbox label="其他"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ruleForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
        hysj: '',
        fqr: '',
        fqrys: '',
        xuxh: '',
        xuxm: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur'},
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur'}
        ],
        region: [
          { required: true, message: '请选择活动区域', trigger: 'change'}
        ],
        date1: [
          { type: 'date', required: true, message: '请选择日期', trigger: 'change'}
        ],
        date2: [
          { type: 'date', required: true, message: '请选择时间', trigger: 'change'}
        ],
        type: [
          { type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change'}
        ],
        resource: [
          { required: true, message: '请选择活动资源', trigger: 'change'}
        ],
        desc: [
          { required: true, message: '请填写活动形式', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  mounted() {

  }
}
</script>

<style>
  .Crisis_addmulti_talk{width: 100%;height: 100%;background-color: #fff;}
  .Crisis_addmulti_talk .demo-ruleForm{padding-top: 20px;}
  .Crisis_addmulti_talk .el-input{width: 240px;}
  .Crisis_addmulti_talk .el-form-item__label{width: 130px !important;text-align: left;margin-left: 20px;}
  .Crisis_addmulti_talk .el-form-item__content{width: 240px !important;margin-left: 150px !important;}
  .Crisis_addmulti_talk .el-textarea{width: 500px !important;}
  .Crisis_addmulti_talk .cgtrh .el-form-item__content{width: 1200px !important;}
</style>